import React from 'react';
import { useTranslation } from '../../../../i18n';
import { getBonusIntro } from '../../../../i18n/helpers';
import { LongestWordLetterRow } from './LongestWordLetterRow';
import './longest-word.css';

interface LongestWordHostProps {
  letters: string;
  roundEnded: boolean;
  /** Show ideal longest word after round ends (same pattern as word-order reveal). */
  correctAnswer?: string;
}

/**
 * Casting host during play: title + frozen 10-letter row.
 * Intro rolling letters live in BonusIntro for this game type.
 */
export const LongestWordHost: React.FC<LongestWordHostProps> = ({
  letters,
  roundEnded,
  correctAnswer,
}) => {
  const { t } = useTranslation();
  const title = getBonusIntro('longest-word').title;

  return (
    <div className="longest-word-host">
      {!roundEnded && (
        <h2 className="bonus-game-playing-title longest-word-host__title">{title}</h2>
      )}
      {roundEnded && correctAnswer ? (
        <div className="longest-word-host__reveal">
          <div className="bonus-host-glow-text--muted longest-word-host__reveal-label">
            {t('bonus.player.longestWordIdealLabel')}
          </div>
          <h2 className="bonus-host-glow-text longest-word-host__reveal-word">{correctAnswer}</h2>
        </div>
      ) : (
        <LongestWordLetterRow letters={letters} rolling={false} size="host" />
      )}
    </div>
  );
};
